var config = {
    API_HOST: 'CF_API_HOST',
    APP_ENV: 'CF_APP_ENV',
    ASSETS_HOST: 'CF_ASSETS_HOST',
    AUTH_DOMAIN: 'CF_AUTH_DOMAIN'
};
export default config;
//# sourceMappingURL=config.js.map